module.exports = __webpack_public_path__ + "static/esco-8-6cb46c5edb94ae83b5bc79bffa331c94.png";